import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-address-auto-complete',
  templateUrl: './address-auto-complete.component.html',
  styleUrls: ['./address-auto-complete.component.scss']
})
export class AddressAutoCompleteComponent implements OnInit {
  ngOnInit(): void {

  }
  @Input() highlight: boolean = false;
  @Input() readOnly: boolean = false;
  @Input() index!: number;
  @Input() placeholder = 'Search';
  @Input() initialValue = '';
  @Input() selectedAddress: string = '';

  @Output() placeSelected = new EventEmitter<any>();
  @Output() inputChange = new EventEmitter<any>();

  selectedAddressText: { [index: number]: string } = {};
  suggestions: any[] = [];

  handleInput(event: Event) {
    this.inputChange.emit(event); // emits to parent like (input)
  }

  onSuggestions(suggestions: any) {
    this.suggestions = suggestions;
  }

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.selectedAddressText[this.index] = value;
  }

  async selectSuggestion(suggestion: any) {
    const place = suggestion.placePrediction.toPlace();

    await place.fetchFields({
      fields: ['addressComponents', 'formattedAddress', 'location']
    });

    const lat = place.location?.lat?.();
    const lng = place.location?.lng?.();

    const placeData = {
      ...place.toJSON(),
      geometry: {
        location: {
          lat,
          lng
        }
      }
    };

    this.selectedAddressText[this.index] = place.formattedAddress || '';
    this.suggestions = [];
    this.placeSelected.emit(placeData);
  }

}
